<template>
  <div class="pointModal">
    <q-linear-progress v-if="this.isFetching" indeterminate />
    <div class="pointModal__content">
      <h2 class="pointModal__title">{{ this.pointInfo?.check_name || '' }}</h2>
      <p class="pointModal__comments">
        <span style="color: #404040">Статус: </span
        ><span
          :style="`color: ${this.getStatusColor()}`"
          >{{ this.pointInfo?.is_accepted ? 'Завершен' : this.pointInfo?.is_accepted === false ? 'Есть замечания' : 'На проверке' }}</span
        >
      </p>
      <p class="pointModal__comments">
        <span style="color: #404040">Комментарии: </span
        >{{ this.pointInfo?.comments || '' }}
      </p>

      <div class="pointModal__images">
        <CustomImg
          v-for="(url, idx) in this.pointInfo.file_urls"
          :key="idx"
          :src="API_URL + url"
          class="pointModal__image"
          errorClass="pointModal__image_error"
          :alt="`Фото замечания ${idx + 1}`"
          :isStaticImg="true"
          :onClick="() => onImageClick(idx)"
        />
      </div>
      <q-dialog
        v-model="this.showGallery"
        transition-show="scale"
        transition-hide="scale"
      >
        <ModalGallery :data="this.galleryData" />
      </q-dialog>
    </div>
  </div>
</template>

<script>
import { API_URL } from '@/constants';
import CustomImg from '@/components/common/CustomImg';
import { getFloorMapPointInfo } from "@/views/ResidentialSettings/services";
import ModalGallery from "@/components/modal/modals/modal-gallery";

export default {
  name: "schema-point-info",
  components: {CustomImg, ModalGallery},
  props: ['data'],
  data() {
    return {
      API_URL,
      pointInfo: {},
      isFetching: false,
      galleryData: null,
      showGallery: false,
    }
  },
  computed: {
    files() {
      return this.pointInfo.file_urls?.map(url => ({file_url: API_URL + url, file_name: url.split('/').reverse()[0], isStaticImg: true}))
    }
  },
  methods: {
    async getData() {
      const {data} = this.data
      this.isFetching = true
      const res = await getFloorMapPointInfo(data?.floorMapId, data?.call_check_list_point_id)
      this.isFetching = false
      if(!res) return
      this.pointInfo = res
    },
    onImageClick(idx) {
      this.openGallery(idx)
    },
    openGallery(idx) {
      this.galleryData = {imgIndex: idx, files: this.files}
      this.showGallery = true;
    },
    getStatusColor() {
      if(this.pointInfo?.is_accepted) return 'green'
      if(this.pointInfo?.is_accepted === false) return 'red'
      return 'orange'
    },
  },
  mounted() {
    this.getData()
  }
}
</script>

<style scoped lang="scss">
.pointModal {
  width: 500px;

  @media (max-width: 576px) {
    width: 100%;
  }
}

.pointModal__title {
  margin-bottom: 12px;
  font-size: 20px;
  line-height: 27px;
}

.pointModal__comments {
  margin-bottom: 10px;
}

.pointModal__images {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
}

.pointModal__image {
  width: 120px;
  height: 150px;
  object-fit: cover;
  border-radius: 12px;
  cursor: pointer;

  &_error {
    height: auto;
  }
}

.pointModal__close {
  margin-top: 20px;
  padding: 8px 16px;
}
</style>
